<div *ngIf="'marketing.newsletterSubscriptionEnabled' | ishServerSetting" class="row form-group">
  <div [class.has-error]="showError" class="offset-md-4 col-md-8">
    <div class="form-check" [attr.data-testing-id]="'registration_newsletter-wrapper'">
      <input
        type="checkbox"
        [formControl]="formControl"
        [formlyAttributes]="field"
        [attr.data-testing-id]="field.key"
        class="form-check-input"
      />
      <label class="form-check-label" [attr.for]="id">
        <div>{{ 'registration.newsletter_subscription.text' | translate }}</div>
      </label>
    </div>
  </div>
</div>
